﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("page-post-results")) {
        const postFilters: HTMLElement | null = document.querySelector(
            ".page-post-results__filters-container"
        );
        if (postFilters) {
            upOrDownOnScrollWheel(postFilters);
        }
    }
    if (body.classList.contains("job-results")) {
        const jobFilters: HTMLElement | null = document.querySelector(
            ".job-results__filters-container"
        );

        if (jobFilters) {
            upOrDownOnScrollWheel(jobFilters);
        }
    }
}


export const jobFiltersLocationClickHandler = () => {
    const filter = document.querySelector<HTMLDivElement>('.jobs .location-filter');
    if (!filter) return;

    const filterHeader = filter.querySelector<HTMLHeadingElement>('.header');
    if (!filterHeader) return;

    filterHeader.setAttribute('tabindex', '0');
    filterHeader.setAttribute('role', 'button');

    const sliderWrapper = filter.querySelector<HTMLElement>('.location-slider-wrapper');

    filterHeader.addEventListener('click', () => {
        sliderWrapper?.classList.toggle('location-slider-wrapper--open');
    });

    filterHeader.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            filterHeader.click()
        }
    });
};

export const jobFiltersSearchFilterAccessibility = () => {
    const searchFiltersWidget = document.querySelector<HTMLElement>('.search-filters-widget__filter-list');
    if (!searchFiltersWidget) return;

    const filterSearch = searchFiltersWidget.querySelector<HTMLElement>('.search-filters-widget__filter-search');
    if (!filterSearch) return;

    const input = filterSearch.querySelector<HTMLInputElement>('input');
    if (!input) return;

    input.setAttribute('aria-label', '{{js.job.filters.search.filter.input.aria-label}}');
};


export const postFiltersBtnClickHandler = () => {
    const filterButton = document.querySelector<HTMLElement>(".page-post-results__filter-btn");
    const filterWrapper = document.querySelector<HTMLElement>(".page-post-results__filter-wrapper");

    if (!filterButton || !filterWrapper) return;


    filterButton.addEventListener("click", () => {
        filterWrapper.classList.toggle("page-post-results__filter-wrapper--open");
        filterButton.setAttribute("aria-expanded", filterButton.getAttribute("aria-expanded") === "true" ? "false" : "true");
        filterButton.classList.toggle("page-post-results__filter-btn--active");
        filterButton.setAttribute("aria-label", filterButton.getAttribute("aria-label") === "close" ? "open filters" : "close filters");
    });
};

export const postFiltersAccessibility = () => {
    const postFilters = document.querySelectorAll(".attrax-post-filters");
    if (!postFilters) return;

    postFilters.forEach((filter) => {
        const filterHeadings = filter.querySelectorAll(
            ".attrax-post-filters__heading-container"
        );

        filterHeadings.forEach((heading: HTMLElement) => {
            heading.setAttribute("tabindex", "0");
            heading.setAttribute("role", "button");
            heading.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    heading.click();
                }
            });
        });
    });

};